import React from 'react';
import './style.less';

const SearchIcon = () => (
    <svg className="search__icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g fillRule="nonzero" fill="#353E44">
            <path d="M6.793 11.793L1.27 17.316c-.39.39-.39 1.023 0 1.414.39.39 1.024.39 1.414 0l5.523-5.523c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0z"/>
            <path d="M12 13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0 2c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7z"/>
        </g>
    </svg>
);

export default SearchIcon;
